import { render } from "./addPointsType.vue?vue&type=template&id=ac619130&scoped=true"
import script from "./addPointsType.vue?vue&type=script&lang=js"
export * from "./addPointsType.vue?vue&type=script&lang=js"

import "./addPointsType.vue?vue&type=style&index=0&id=ac619130&lang=scss"
import "./addPointsType.vue?vue&type=style&index=1&id=ac619130&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/test-event-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ac619130"],['__file',"src/views/marketing/components/addPointsType.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "ac619130"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('ac619130', __exports__)) {
    console.log('reload')
    api.reload('ac619130', __exports__)
  }
  
  module.hot.accept("./addPointsType.vue?vue&type=template&id=ac619130&scoped=true", () => {
    console.log('re-render')
    api.rerender('ac619130', render)
  })

}


export default __exports__